import { sha256 } from './sha256';

// /**
//  * Create request ID
//  * @deprecated
//  */
// export async function _requestId(value: Partial<RequestValue>, type: RequestType): Promise<string> {
//   if (type == RequestType.Track) {
//     value = value as ITrack;

//     if (value.artist && value.title && value.collection) {
//       return await sha256(`${value.artist} - ${value.title} - ${value.collection}`);
//     }

//     console.error('Failed creating request ID: Track parameters missing');
//     return '';
//   } else {
//     return await sha256((value as string).toLowerCase());
//   }
// }

export function requestHash(title: string, artist?: string): Promise<string> {
  if (artist) {
    return sha256(`${artist.toLowerCase()}-${title.toLowerCase()}`);
  }

  return sha256(title.toLowerCase());
}
